import React, { ReactNode } from "react";
import styled from "styled-components";

interface PageTitleProps {
  icon?: ReactNode;
  children: ReactNode;
  subtitle?: string;
}

const TitleContainer = styled.div`
  margin-bottom: 2rem;
`;

const TitleWrapper = styled.h1`
  color: #ffffff;
  font-size: 2.2rem;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 15px;

  svg {
    font-size: 1.8rem;
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  margin-top: 0;
  margin-bottom: 1.5rem;
  max-width: 600px;
  line-height: 1.5;
`;

export const PageTitle: React.FC<PageTitleProps> = ({
  icon,
  children,
  subtitle,
}) => {
  return (
    <TitleContainer>
      <TitleWrapper>
        {icon && icon}
        {children}
      </TitleWrapper>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </TitleContainer>
  );
};
